import React, {ButtonHTMLAttributes, forwardRef, ReactNode} from 'react';

import {TooltipProps} from 'react-tooltip';

import {Tooltip} from '../Tooltip';

import {ButtonInner, ButtonRoot} from './styled';

/* Example
 *  <IconButton
 *   onClick={console.log}
 *   label="Удалить"
 *   icon={<Icon source={TestIcon} width={16} height={16} />}
 *  />
 * */

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    label?: string;
    labelPlace?: TooltipProps['place'];
    icon: ReactNode;
    hoverIndication?: boolean;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
    ({label, labelPlace, icon, hoverIndication, ...otherProps}, ref) => (
        <>
            {label && <Tooltip place={labelPlace} />}
            <ButtonRoot
                ref={ref}
                hoverIndication={hoverIndication}
                {...otherProps}
                data-tip={label}
            >
                <ButtonInner>{icon}</ButtonInner>
            </ButtonRoot>
        </>
    ),
);
